import { APICall } from "../service"

const ControllerName = "Government"

export const GetGovernmentLookup = (lang) => {
    return APICall("get", ControllerName + "/lookup", {}, lang)
}
export const GetGovernmentAreaLookup = (GovIds = [], lang) => {
    console.log(GovIds)
    GovIds = !GovIds ? [] : GovIds.map(id => id)
    const queryParams = GovIds?.map(id => `governmentIds=${id}`).join('&')
    return APICall("get", `${ControllerName}/Area/lookup?${queryParams}`)
}